<template>
    <CCard class="page mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody>
            <CContainer fluid class="p-0">
                <CForm
                    ref="formViewProviderIntegration"
                    @submit="submitForm($event, 'viewProviderIntegration')"
                >
                    <CTabs variant="tabs" :active-tab="0">
                        <!--  Tab General -->
                        <CTab :title="$t('general')">
                            <CCard>
                                <CCardBody>
                                    <CContainer class="p-0">
                                        <CRow class="mb-3">
                                            <CCol sm="12">
                                                <h5>
                                                    {{
                                                        $t(
                                                            "Set an 3th party connect"
                                                        )
                                                    }}
                                                </h5>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol sm="12">
                                                <CInput
                                                    :isValid="
                                                        checkIfFormValid({
                                                            formName:
                                                                'viewProviderIntegration',
                                                            fieldName: 'name',
                                                        })
                                                    "
                                                    :placeholder="
                                                        $t('enter_the_name')
                                                    "
                                                    :value.sync="
                                                        $v.forms
                                                            .viewProviderIntegration
                                                            .name.$model
                                                    "
                                                    :label="$t('name')"
                                                    v-bind="defaultInputConfig"
                                                />
                                            </CCol>
                                        </CRow>
                                        <CRow alignVertical="center">
                                            <CCol md="12" sm="12">
                                                <h5>
                                                    {{ $t("Plugin") }}
                                                </h5>
                                                <p class="mb-1">
                                                    {{
                                                        $t(
                                                            "Select the integration from which you want to make the connection"
                                                        )
                                                    }}
                                                </p>
                                                <SelectAsync
                                                    size="sm"
                                                    :placeholder="
                                                        $t('select_a_plugin')
                                                    "
                                                    :options="
                                                        listPluginsIntegration
                                                    "
                                                    :optionsValue="'uuid'"
                                                    :optionsLabel="'name'"
                                                    :value.sync="
                                                        $v.forms
                                                            .viewProviderIntegration
                                                            .plugin_marketing_credentials_uuid
                                                            .$model
                                                    "
                                                    @change="getListActions()"
                                                    :isValid="
                                                        checkIfFormValid({
                                                            formName:
                                                                'viewProviderIntegration',
                                                            fieldName:
                                                                'plugin_marketing_credentials_uuid',
                                                        })
                                                    "
                                                    :disabled="
                                                        viewType == 'edit' &&
                                                        forms
                                                            .viewProviderIntegration
                                                            .action_uuid ==
                                                            $options.consts
                                                                .BREVO_ACTION_WEBHOOK_GET_STATS
                                                    "
                                                />
                                            </CCol>
                                        </CRow>

                                        <CRow
                                            alignVertical="center"
                                            v-if="
                                                forms.viewProviderIntegration
                                                    .plugin_marketing_credentials_uuid
                                            "
                                        >
                                            <CCol md="12" sm="12">
                                                <h5>
                                                    {{ $t("action") }}
                                                </h5>
                                                <p class="mb-1">
                                                    {{
                                                        $t(
                                                            "Select the action you want to perform"
                                                        )
                                                    }}
                                                </p>
                                                <SelectAsync
                                                    size="sm"
                                                    :placeholder="
                                                        $t('select_action')
                                                    "
                                                    :options="listActions"
                                                    :optionsValue="'id'"
                                                    :optionsLabel="'name'"
                                                    :value.sync="
                                                        $v.forms
                                                            .viewProviderIntegration
                                                            .action_uuid.$model
                                                    "
                                                    :isValid="
                                                        checkIfFormValid({
                                                            formName:
                                                                'viewProviderIntegration',
                                                            fieldName:
                                                                'action_uuid',
                                                        })
                                                    "
                                                    :disabled="
                                                        viewType == 'edit' &&
                                                        forms
                                                            .viewProviderIntegration
                                                            .action_uuid ==
                                                            $options.consts
                                                                .BREVO_ACTION_WEBHOOK_GET_STATS
                                                    "
                                                />
                                            </CCol>
                                        </CRow>
                                    </CContainer>
                                </CCardBody>
                                <CCardFooter class="d-flex">
                                    <ButtonSave
                                        color="success"
                                        @click="
                                            executeSubmitForm(
                                                'formViewProviderIntegration'
                                            )
                                        "
                                        :disabled="
                                            forms.viewProviderIntegration
                                                ._loading
                                        "
                                    />
                                    <ButtonBack class="mr-3" title="Go back" />
                                </CCardFooter>
                            </CCard>
                        </CTab>
                        <CTab
                            :title="$t('settings')"
                            v-if="
                                forms.viewProviderIntegration
                                    .plugin_marketing_credentials_uuid &&
                                forms.viewProviderIntegration.action_uuid
                            "
                        >
                            <CCard>
                                <CCardBody>
                                    <FacebookGetLeadActionSettings
                                        ref="facebookGetLeadAction"
                                        v-if="
                                            forms.viewProviderIntegration
                                                .action_uuid ==
                                            $options.consts
                                                .FACEBOOK_ACTION_GET_LEAD
                                        "
                                        :key="facebookGetLeadActionSettingsKey"
                                        :plugin_marketing_credentials_uuid="
                                            forms.viewProviderIntegration
                                                .plugin_marketing_credentials_uuid
                                        "
                                        :value.sync="
                                            forms.viewProviderIntegration
                                                .settings
                                        "
                                    />
                                    <BrevoWebhookGetStatsActionSettings
                                        ref="brevoWebhookGetStatsAction"
                                        v-if="
                                            forms.viewProviderIntegration
                                                .action_uuid ==
                                            $options.consts
                                                .BREVO_ACTION_WEBHOOK_GET_STATS
                                        "
                                        :key="
                                            brevoWebhookGetStatsActionSettingsKey
                                        "
                                        :plugin_marketing_credentials_uuid="
                                            forms.viewProviderIntegration
                                                .plugin_marketing_credentials_uuid
                                        "
                                        :view_type="viewType"
                                        :value.sync="
                                            forms.viewProviderIntegration
                                                .settings
                                        "
                                    />
                                </CCardBody>
                                <CCardFooter class="d-flex">
                                    <ButtonSave
                                        color="success"
                                        @click="
                                            executeSubmitForm(
                                                'formViewProviderIntegration'
                                            )
                                        "
                                        :disabled="
                                            forms.viewProviderIntegration
                                                ._loading
                                        "
                                    />
                                    <ButtonBack class="mr-3" title="Go back" />
                                </CCardFooter>
                            </CCard>
                        </CTab>
                    </CTabs>
                </CForm>
            </CContainer>
        </CCardBody>
    </CCard>
</template>
<script>
/** Components */
import ButtonBack from "£lement/ButtonBack";
import SelectAsync from "£lement/SelectAsync";
import ButtonSave from "~/components/ButtonSave.vue";
import FacebookGetLeadActionSettings from "~/pages/app/inputs/Integrations/Components/FacebookGetLeadActionSettings.vue";
import BrevoWebhookGetStatsActionSettings from "~/pages/app/inputs/Integrations/Components/BrevoWebhookGetStatsActionSettings.vue";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import { validationMixin } from "vuelidate";
import formMixin from "~/mixins/form";

/** Others */
import { cilTrash, cilArrowBottom, cilArrowTop, cilPlus } from "@coreui/icons";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import {
    FACEBOOK_ACTION_GET_LEAD,
    BREVO_ACTION_WEBHOOK_GET_STATS,
} from "~/pages/app/inputs/Integrations/Config/Types";

export default {
    name: "InputsIntegrationsViewPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, formMixin, validationMixin],
    icons: {
        cilTrash,
        cilArrowTop,
        cilArrowBottom,
        cilPlus,
    },
    consts: {
        FACEBOOK_ACTION_GET_LEAD,
        BREVO_ACTION_WEBHOOK_GET_STATS,
    },
    components: {
        ButtonBack,
        SelectAsync,
        ButtonSave,
        FacebookGetLeadActionSettings,
        BrevoWebhookGetStatsActionSettings,
    },
    data() {
        return {
            forms: {
                viewProviderIntegration: {
                    name: null,
                    plugin_marketing_credentials_uuid: null,
                    action_uuid: null,
                    settings: {},
                    _loading: false,
                    _matchResponse: "_items",
                },
            },
            listPluginsActions: [],
            listPluginsIntegration: [],
            listActions: [],
            facebookGetLeadActionSettingsKey: 0,
            brevoWebhookGetStatsActionSettingsKey: 0,
        };
    },
    validations: {
        forms: {
            viewProviderIntegration: {
                name: {
                    required,
                },
                plugin_marketing_credentials_uuid: {
                    required,
                },
                action_uuid: {
                    required,
                },
            },
        },
    },
    computed: {
        ...mapGetters({
            storePlugins: "global/plugins",
            storePluginIntegrations: "global/pluginIntegrations",
        }),
        viewType: function () {
            return this.routeName.includes("edit") ? "edit" : "create";
        },
        uuid: function () {
            return this.$route.params.uuid;
        },
        pluginIntegration() {
            let find = this.storePluginIntegrations.find(
                (pluginIntegration) =>
                    pluginIntegration.uuid ==
                    this.forms.viewProviderIntegration
                        .plugin_marketing_credentials_uuid
            );
            return find;
        },
    },
    watch: {
        "forms.viewProviderIntegration._loading": function (val) {
            this.updatePageLoading(val);
        },
        "settings.providerUuid": {
            handler: function (newValue) {
                this.forms.viewProviderIntegration.settings = {
                    ...this.forms.viewProviderIntegration.settings,
                    providerUuid: newValue,
                };
            },
            deep: true,
        },
        "settings.pageId": {
            handler: function (newValue) {
                this.forms.viewProviderIntegration.settings = {
                    ...this.forms.viewProviderIntegration.settings,
                    pageId: newValue,
                };
            },
            deep: true,
        },
        "settings.formId": {
            handler: function (newValue) {
                this.forms.viewProviderIntegration.settings = {
                    ...this.forms.viewProviderIntegration.settings,
                    formId: newValue,
                };
            },
            deep: true,
        },
        "settings.fieldsMapping.items": {
            handler: function (newValue) {
                this.forms.viewProviderIntegration.settings = {
                    ...this.forms.viewProviderIntegration.settings,
                    fieldsMapping: newValue,
                };
            },
            deep: true,
        },
        "settings.fixedFields": {
            handler: function (newValue) {
                this.forms.viewProviderIntegration.settings = {
                    ...this.forms.viewProviderIntegration.settings,
                    fixedFields: newValue,
                };
            },
            deep: true,
        },
        "settings.dynamicFields": {
            handler: function (newValue) {
                this.forms.viewProviderIntegration.settings = {
                    ...this.forms.viewProviderIntegration.settings,
                    dynamicFields: newValue,
                };
            },
            deep: true,
        },
        "forms.viewProviderIntegration.plugin_marketing_credentials_uuid":
            function (newValue, oldValue) {
                if (newValue && oldValue) {
                    if (newValue != oldValue) this.resetSettings();
                }
            },
    },
    methods: {
        resetSettings() {
            if (
                this.forms.viewProviderIntegration.action_uuid ==
                this.$options.consts.FACEBOOK_ACTION_GET_LEAD
            ) {
                this.forms.viewProviderIntegration.settings = {
                    providerUuid: null,
                    pageId: null,
                    formId: null,
                    fieldsMapping: [],
                    fixedFields: [],
                    dynamicFields: [],
                };
                this.facebookGetLeadActionSettingsKey += 1;
            } else if (
                this.forms.viewProviderIntegration.action_uuid ==
                this.$options.consts.BREVO_ACTION_WEBHOOK_GET_STATS
            ) {
                this.forms.viewProviderIntegration.settings = {
                    type: null,
                };
                this.brevoWebhookGetStatsActionSettingsKey += 1;
            } else {
                this.forms.viewProviderIntegration.settings = {};
            }
        },
        getListActions() {
            if (this.pluginIntegration.driver_id) {
                this.listActions = this.findPluginByDriverId(
                    this.pluginIntegration.driver_id
                ).actions;
            }
        },
        async submitForm(e, formName) {
            e.preventDefault();
            if (this.viewType == "edit") {
                await this.sendForm({
                    formName,
                    url: "/provider-integrations/" + this.uuid,
                    method: "PUT",
                });
            } else {
                await this.sendForm({
                    formName,
                    url: "/provider-integrations",
                });
            }

            this.$router.push({ name: "3th_party_connections" });
        },
        async loadPluginIntegrations() {
            if (this.storePluginIntegrations.length == 0) {
                let pluginIntegrations = await this.fetcher({
                    url: '/connector.api/getPluginsCredentials?query=""',
                });

                this.$store.dispatch("global/savePluginIntegrations", {
                    pluginIntegrations: pluginIntegrations._items,
                });
            }

            this.storePluginIntegrations.map((item) => {
                if (this.findPluginByDriverId(item.driver_id))
                    this.listPluginsIntegration.push(item);
            });
        },
        async loadPluginsActions() {
            if (this.listPluginsActions.length == 0) {
                let pluginIntegrations = await this.fetcher({
                    url: "/provider-integrations/plugins/getlist",
                });
                this.listPluginsActions = pluginIntegrations._items;
            }
        },
        findPluginByDriverId(driverId) {
            return this.listPluginsActions.find((plugin) => {
                return plugin.uuid == driverId;
            });
        },
        isInvalidForm(formName) {
            let valForm = this.getValidateForm(formName);
            if (!valForm) return false;
            valForm.$touch();

            if (!valForm.$invalid) {
                if (
                    this.forms.viewProviderIntegration.action_uuid ==
                    this.$options.consts.FACEBOOK_ACTION_GET_LEAD
                ) {
                    if (!this.$refs.facebookGetLeadAction.validateSettings()) {
                        return true;
                    }
                } else if (
                    this.forms.viewProviderIntegration.action_uuid ==
                    this.$options.consts.BREVO_ACTION_WEBHOOK_GET_STATS
                ) {
                    if (
                        !this.$refs.brevoWebhookGetStatsAction.validateSettings()
                    ) {
                        return true;
                    }
                }
            }

            return valForm.$invalid;
        },
    },
    async mounted() {
        await this.loadPluginsActions();
        await this.loadPluginIntegrations();
        if (this.viewType == "edit") {
            await this.updateForm({
                formName: "viewProviderIntegration",
                url: "provider-integrations/" + this.uuid,
                adapterData: (data) => {
                    if (data.settings) {
                        data.settings = JSON.parse(data.settings);
                    }
                    return data;
                },
            });
        }
        this.updatePageLoading(false);
    },
};
</script>

<style lang="scss" scoped>
.input-fields {
    margin-bottom: 1rem;
}
.ui.fluid.search.selection.dropdown.form-control.disabled {
    background-color: #e9ecef;
    opacity: 1;
}
</style>
